const major = 1;
const minor = 11;
const patch = 3;

module.exports = `${major}.${minor}.${patch}`;
